import { PropTypes } from 'prop-types';
import { useRecoilValue } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';

import Utils from '@/common/utils/utils';
import ChatGPTModelDropdown from './ChatGPTModelDropdown';
import ReferenceKnowledge from './ReferenceKnowledge';

GroupButtonKnowledge.propTypes = {
    API: PropTypes.any,
    projectInfo: PropTypes.any,
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    reOpenKnowledgePanel: PropTypes.any,
    projectIdKnowledgeSelected: PropTypes.any,
    isInvalidPrecondition: PropTypes.any,
    tabNameChatAI: PropTypes.any,
    corporationSelected: PropTypes.any,
    initHitNumber: PropTypes.any,
    isUsingKnowledgeService: PropTypes.any,
    toggleUsingKnowledgeTicketList: PropTypes.any,
    setToggleUsingKnowledgeTicketList: PropTypes.any,
    usingChatGptModel: PropTypes.any,
    setUsingChatGptModel: PropTypes.any,
    selectedMcpServers: PropTypes.array,
    setSelectedMcpServers: PropTypes.func,
    usingReasoningEffort: PropTypes.any,
    setUsingReasoningEffort: PropTypes.any,
    selectedCorporationDetail: PropTypes.any,
    chatGPTModelListOptions: PropTypes.any
};


export default function GroupButtonKnowledge({
    chatThreadId,
    projectInfo,
    panelId,
    tabId,
    reOpenKnowledgePanel,
    projectIdKnowledgeSelected,
    isInvalidPrecondition,
    initHitNumber,
    isUsingKnowledgeService,
    toggleUsingKnowledgeTicketList,
    setToggleUsingKnowledgeTicketList,
    usingChatGptModel,
    setUsingChatGptModel,
    selectedMcpServers,
    usingReasoningEffort,
    setUsingReasoningEffort,
    chatGPTModelListOptions
}) {
    const corporationDetail = useRecoilValue(corporationAtom);
    let chatGPTModelListOfCorp = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting)?.listChatGptModel;

    return (
        <div className="group-button-chat-ai-wrapper">
            <div className="group-button-chat-ai-container">
                <ReferenceKnowledge
                    chatThreadId={chatThreadId}
                    projectInfo={projectInfo}
                    panelId={panelId}
                    tabId={tabId}
                    reOpenKnowledgePanel={reOpenKnowledgePanel}
                    projectIdKnowledgeSelected={projectIdKnowledgeSelected}
                    isInvalidPrecondition={isInvalidPrecondition}
                    initHitNumber={initHitNumber}
                    isUsingKnowledgeService={isUsingKnowledgeService}
                    toggleUsingKnowledgeTicketList={toggleUsingKnowledgeTicketList}
                    setToggleUsingKnowledgeTicketList={setToggleUsingKnowledgeTicketList}
                    selectedMcpServers={selectedMcpServers}
                />

                <div style={{display: 'flex', flexShrink: 0, alignItems: 'center'}}>
                    {/* ChatGPT Multi-Select Dropdown */}
                    <ChatGPTModelDropdown
                        usingChatGptModel={usingChatGptModel}
                        setUsingChatGptModel={setUsingChatGptModel}
                        usingReasoningEffort={usingReasoningEffort}
                        setUsingReasoningEffort={setUsingReasoningEffort}
                        chatGPTModelListOptions={chatGPTModelListOptions}
                        chatGPTModelListOfCorp={chatGPTModelListOfCorp}
                    />
                </div>
            </div>
        </div>
    );
}
